import { Navigate, Outlet, useSearchParams } from 'react-router';
import { FullPageLoader } from '@/components/full-page-state';
import { ROUTES, safeRedirect } from '@/shared/config/routes';
import { useViewer } from '../hooks/use-viewer';

/** Sign-in routes. A signed-in person goes on to where they were heading. */
export function GuestGuard() {
  const { viewer, workspace, isLoading } = useViewer();
  const [searchParams] = useSearchParams();

  if (isLoading) return <FullPageLoader />;
  if (viewer) {
    const target = workspace
      ? (safeRedirect(searchParams.get('redirect')) ?? ROUTES.OVERVIEW)
      : ROUTES.WELCOME;
    return <Navigate to={target} replace />;
  }
  return <Outlet />;
}
